const FB_EVENTS_SCRIPT = 'https://connect.facebook.net/en_US/fbevents.js'

/**
 * substitutes react-facebook-pixel init.
 *
 * @see https://developers.facebook.com/docs/meta-pixel/get-started
 */
function ensureFacebookPixelBase(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  const w = window as Window & { _fbq?: unknown }
  const fbqStub: any = function () {
    if (fbqStub.callMethod) {
      // eslint-disable-next-line prefer-spread, prefer-rest-params
      fbqStub.callMethod.apply(fbqStub, arguments)
    } else {
      // eslint-disable-next-line prefer-rest-params
      fbqStub.queue.push(arguments)
    }
  }

  window.fbq = fbqStub
  if (!w._fbq) w._fbq = fbqStub
  fbqStub.push = fbqStub
  fbqStub.loaded = true
  fbqStub.version = '2.0'
  fbqStub.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = FB_EVENTS_SCRIPT
  const first = document.getElementsByTagName('script')[0]
  first?.parentNode?.insertBefore(script, first)
}

export type FacebookPixelAdvancedMatching = Record<string, string>

export function initFacebookPixel(
  pixelId: string | undefined,
  advancedMatching: FacebookPixelAdvancedMatching = {},
): void {
  if (!pixelId) return
  ensureFacebookPixelBase()
  window.fbq?.('init', pixelId, advancedMatching)
}

export type FacebookPixelTrackOptions = {
  eventID?: string
}

export function sendFacebookPixelTrack(
  eventName: string,
  payload?: object,
  trackOptions?: FacebookPixelTrackOptions,
): void {
  const fbq = window.fbq
  if (!fbq) return
  if (payload !== undefined && trackOptions !== undefined) {
    fbq('track', eventName, payload, trackOptions)
  } else if (payload !== undefined) {
    fbq('track', eventName, payload)
  } else {
    fbq('track', eventName)
  }
}
